"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = PriceLockupV1;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _density = require("@site/pattern-library-utils/density");
var _core = require("@linaria/core");
var _text = _interopRequireDefault(require("@ux/text"));
var _index = _interopRequireDefault(require("../tag/index.js"));
var _index2 = _interopRequireDefault(require("../paragraph/index.js"));
const priceLockupElement = "core-pklz8bz";
const priceDetail = "core-p9sxv7f";
const priceWrapper = "core-pxi9vj8";
const belowPriceStyles = "core-b119o4ao";

/**
 * Price Lockup for Product Card Component
 *
 * @param {Object} props React props
 * @param {string} props.saleCallout Tag label text
 * @param {Node} props.price Product price value
 * @param {string} props.abovePriceText Above-price label
 * @param {string} props.renewText Renewal price detail (e.g., '/mo')
 * @param {string} props.belowPrice Below-price text
 * @returns {React.ReactElement} Price component
 * @public
 */
function PriceLockupV1({
  saleCallout,
  price,
  abovePriceText,
  renewText,
  belowPrice,
  align = 'start'
}) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _core.cx)('priceLockup', `align-${align}`, priceLockupElement),
    "data-cy": "price-lockup-v1"
  }, abovePriceText && /*#__PURE__*/_react.default.createElement("small", null, " ", abovePriceText, " "), /*#__PURE__*/_react.default.createElement("div", {
    className: priceWrapper
  }, price && /*#__PURE__*/_react.default.createElement(_text.default.h3, {
    as: "heading",
    size: 2,
    "data-cy": "price-heading",
    className: "price-heading"
  }, price), renewText && /*#__PURE__*/_react.default.createElement(_index2.default, {
    className: priceDetail
  }, renewText)), saleCallout && /*#__PURE__*/_react.default.createElement(_index.default, {
    text: saleCallout,
    design: "warning"
  }), belowPrice && /*#__PURE__*/_react.default.createElement("small", {
    className: belowPriceStyles
  }, " ", belowPrice, " "));
}
PriceLockupV1.propTypes = {
  align: _propTypes.default.oneOf(['start', 'center', 'end']),
  abovePriceText: _propTypes.default.node,
  price: _propTypes.default.node,
  renewText: _propTypes.default.node,
  saleCallout: _propTypes.default.string,
  belowPrice: _propTypes.default.node
};